import script from "./BrowserTips.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserTips.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserTips.vue?vue&type=style&index=0&id=75b40a00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b40a00"]])

export default __exports__